import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { localStoreFN } from '../../store/localStorage';
import $ from 'jquery';

/* Actions */
import * as headeractions from '../../actions/header/index';
import * as tasksManagerActions from '../../actions/tasks_manager/index';

/*Components*/
import HeaderComponent from '../../components/header/';

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleNotification = async event => {
    const obj = {
      notification: false,
      user: false,
      task: false,
      help: false
    };
    switch (event.target.id) {
      case 'notification':
        obj.notification = this.props.notification ? false : true;
        obj.task = false;
        obj.user = false;
        obj.help = false;
        break;
      case 'task':
        obj.notification = false;
        obj.task = this.props.task ? false : true;
        obj.user = false;
        obj.help = false;
        break;
      case 'user':
        obj.notification = false;
        obj.task = false;
        obj.user = this.props.user ? false : true;
        obj.help = false;
        break;
      case 'user-profile':
        obj.notification = false;
        obj.task = false;
        obj.user = this.props.user ? false : true;
        obj.help = false;
        break;
      case 'help':
        obj.notification = false;
        obj.task = false;
        obj.user = false
        obj.help = this.props.help ? false : true;
      case 'help-repeat-tour':
        obj.notification = false;
        obj.task = false;
        obj.user = false
        obj.help = this.props.help ? false : true;
        break;
    }
    this.props.actions.notification(obj);
  };

  handleTaskIndicatorsClick = event => {
    //const userId = localStoreFN().getItem('userId');
    this.props.tasksManagerActions.setFilterTasksManager({
      date: {
        fechaStartFinal: null,
        fechaEndFinal: null
      },
      tags: [],
      workingShiftGroup: null,
      otherFilters: {
        state: event.target.dataset.type,
        //accountableId: userId
      }
    });
    if(this.props.history.location.pathname == '/dashboard/tasks_manager') {
      this.props.history.push('/dashboard');
      setTimeout(() => {
        this.props.history.push('/dashboard/tasks_manager');
      },1);
    }
    else {
      $('#main_navegation .active').removeClass('active');
      $('#main_navegation .task_manager_menu').addClass('active');
      this.props.history.push('/dashboard/tasks_manager');
    }
  };

  render() {
    const email = localStoreFN().getItem('user');
    const permits = localStoreFN().getItem('permits');
    const language = this.props.language ? this.props.language : '';
    return (
      <HeaderComponent
        email={email}
        handleLogOut={this.props.handleLogOut}
        handleUserProfile={this.props.handleUserProfile}
        task={this.props.task}
        notification={this.props.notification}
        user={this.props.user}
        help={this.props.help}
        helpRepeatTourAction={this.props.helpRepeatTourAction}
        handleNotification={this.handleNotification}
        taskManagerIndicatorsData={this.props.taskManagerIndicators.data}
        handleTaskIndicatorsClick={this.handleTaskIndicatorsClick}
        language={language}
        permits={permits}
      />
    );
  }
}

const mapStateToProps = state => ({
  task: state.reducer.header.task,
  language: state.reducer.dashboard.language,
  notification: state.reducer.header.notification,
  user: state.reducer.header.user,
  help: state.reducer.header.help,
  helpRepeatTourAction: state.reducer.header.helpRepeatTourAction,  
  taskManagerIndicators: state.reducer.dashboard.taskManagerIndicators
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(headeractions, dispatch),
  tasksManagerActions: bindActionCreators(tasksManagerActions, dispatch),
});

Header.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Header);



// WEBPACK FOOTER //
// ./source/client/containers/header/index.jsx